export default {"src":"https://fishbrain.com/_next/static/media/massachusetts.35585db2.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};